import React, { Component } from "react";
import SubNav from "../../shared/subnav/SubNav";
import CustomerReservationTable from "./CustomerReservationTable";
import { withTranslation } from "react-i18next";
import styles from "./CustomerReservation.module.scss";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import CustomerReservationsClient from "../../shared/clients/CustomerReservationsClient";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import { LAST_NAME, ORBIT_NUMBER, VISTA_NUMBER } from "../../common/Constants";

const StyledRadio = withStyles({
  root: {
    color: "#102b4e",
    "&$checked": {
      color: "#102b4e",
    },
  },
  checked: {},
})(Radio);

const StyledRadioGroup = withStyles({
  root: {
    display: "inline",
  },
  checked: {},
})(RadioGroup);

class CustomerReservations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: "",
      isDataLoaded: false,
      tables: {},
      searchEnabled: false,
      fetchFailed: false,
      selectedTab: 0,
      searchOrderType: "orderNumber",
    };
    this.fetchFailed = false;
  }

  componentDidMount() {
    this.props.hideOrShow(true, true);
    const dealers = this.props.user.getCommonIdsWithSDLR().split(",");
    this.getReservations(dealers).finally(() => {
      if (!this.fetchFailed) {
        this.setState({ isDataLoaded: true });
      }
      this.props.hideOrShow(false);
    });
  }

  handleTabChange = (event, selectedTab) => {
    this.props.hideOrShow(true);
    this.setState(
      {
        selectedTab,
        isDataLoaded: false,
        tables: {},
        searchQuery: "",
        searchEnabled: false,
      },
      () => {
        const dealers = this.props.user.getCommonIdsWithSDLR().split(",");
        this.getReservations(dealers).finally(() => {
          if (!this.fetchFailed) {
            this.setState({
              isDataLoaded: true,
            });
          }
          this.props.hideOrShow(false);
        });
      }
    );
  };

  handleOrderSearchChange = (event) => {
    this.setState({
      searchOrderType: event.target.value,
    });
  };

  updateTables = (
    reservations,
    numPages,
    numResults,
    commonDealerId,
    newPage
  ) => {
    const tablesCopy = JSON.parse(JSON.stringify(this.state.tables));
    tablesCopy[commonDealerId] = {
      reservations: reservations,
      numberOfPages: numPages,
      totalNumberOfResults: numResults,
      currentPage: newPage,
    };
    this.setState({ tables: tablesCopy }, () => {
      this.createTablesCopy();
    });
  };

  async getReservations(dealers) {
    this.fetchFailed = false;
    this.setState({ fetchFailed: false });
    const market = this.props.user.market;
    for (const dealerCommonId in dealers) {
      await CustomerReservationsClient.getCustomerReservations(
        this.props.user.token,
        dealers[dealerCommonId],
        0,
        this.props.lang,
        null,
        market,
        this.state.selectedTab
      )
        .then((result) => {
          result.reservations.length &&
            this.parseReservations(
              result.reservations,
              result.pagination.numberOfPages,
              result.pagination.totalNumberOfResults
            );
        })
        .catch(() => {
          this.setState({ fetchFailed: true });
          this.fetchFailed = true;
        })
        .finally(() => {
          this.createTablesCopy();
        });
    }
  }

  parseReservations(reservations, numPages, numResults) {
    const currentTables = JSON.parse(JSON.stringify(this.state.tables));
    const tempReservations = [];
    const dealerId = reservations && reservations[0].dealerId;

    reservations.forEach((reservation) => {
      reservation.orderType =
        reservation.orderType === "pre-order"
          ? this.props.t("CustomerReservations.preOrder")
          : reservation.orderType;
      tempReservations.push(reservation);
    });
    currentTables[dealerId] = {
      reservations: tempReservations,
      numberOfPages: numPages,
      totalNumberOfResults: numResults,
      currentPage: 1,
    };
    this.setState({ tables: currentTables });
  }

  getSubNav() {
    return (
      <SubNav
        dashboard={false}
        title={this.props.t("GlobalNavBar.orders")}
        selectedTab={this.state.selectedTab}
        action={this.handleTabChange}
        tabs={this.getTabs()}
        {...this.props}
      />
    );
  }

  searchOrders = (e) => {
    e.preventDefault();
    this.props.hideOrShow(true);
    const dealers = this.props.user.getCommonIdsForSearch();
    const isVistaOrderSearch = this.state.searchOrderType === VISTA_NUMBER;
    const isOrbitOrderSearch = this.state.searchOrderType === ORBIT_NUMBER;
    const isLastNameSearch = this.state.searchOrderType === LAST_NAME;
    CustomerReservationsClient.searchCustomerReservations(
      this.state.searchQuery.trim(),
      this.props.user,
      this.props.lang,
      dealers,
      this.props.user.market,
      isVistaOrderSearch,
      isOrbitOrderSearch,
      isLastNameSearch
    )
      .then((reservations) => {
        const pageSize = 10;
        const numberOfPages = Math.ceil(reservations.length / pageSize);
        this.setState({ tables: {} });
        this.parseReservations(
          reservations,
          numberOfPages,
          reservations.length
        );
      })
      .catch(() => {
        this.setState({ tables: {} });
      })
      .finally(() => {
        this.setState({ searchEnabled: true });
        this.props.hideOrShow(false);
      });
  };

  clearSearch = () => {
    this.state.searchEnabled &&
      this.setState({
        tables: this.tablesCopy,
        searchQuery: "",
        searchEnabled: false,
      });
  };

  searchOrdersComponent() {
    return (
      <div className="pagePadding">
        <div className={styles.searchWrapper}>
          <div className={styles.searchLabel}>
            {this.props.t("CustomerReservations.searchBy")}
          </div>
          <FormControl component="fieldset">
            <StyledRadioGroup
              name="orderSearch"
              value={this.state.searchOrderType}
              onChange={this.handleOrderSearchChange}
            >
              <FormControlLabel
                value="orderNumber"
                control={<StyledRadio />}
                className={styles.labels}
                data-testid="orderNumber"
                label={this.props.t("CustomerReservations.orderNumber")}
              />
              <FormControlLabel
                value="email"
                control={<StyledRadio />}
                className={styles.labels}
                data-testid="emailSearch"
                label={this.props.t("CustomerReservations.email")}
              />
              <FormControlLabel
                value="vistaNumber"
                control={<StyledRadio />}
                className={styles.labels}
                data-testid="vistaNumber"
                label={this.props.t("CustomerReservations.vistaNumber")}
              />
              <FormControlLabel
                value="orbitNumber"
                control={<StyledRadio />}
                className={styles.labels}
                data-testid="orbitNumber"
                label={this.props.t("CustomerReservations.orbitNumber")}
              />
              <FormControlLabel
                value="lastName"
                control={<StyledRadio />}
                className={styles.labels}
                data-testid="lastName"
                label={this.props.t("CustomerReservations.lastName")}
              />
            </StyledRadioGroup>
          </FormControl>
        </div>
        <div className={styles.searchWrapper}>
          <ValidatorForm className={styles.form} onSubmit={this.searchOrders}>
            <TextValidator
              variant="outlined"
              name="orderSearch"
              value={this.state.searchQuery}
              validators={["required"]}
              errorMessages={[this.props.t("Error.requiredField")]}
              onChange={(e) => {
                this.setState({
                  searchQuery: e.target.value,
                });
              }}
              className={styles.inputField}
              data-testid="orderSearch"
              placeholder={this.props.t(
                "CustomerReservations.searchPlaceholder",
                {
                  searchOrderType: this.props.t(
                    `CustomerReservations.${this.state.searchOrderType}`
                  ),
                }
              )}
            />

            <button
              className={styles.searchButton}
              type="submit"
              data-testid="searchBtn"
            >
              <div className={styles.searchIcon}></div>
            </button>
          </ValidatorForm>
          <button
            className={styles.clear}
            data-testid="clearSearch"
            onClick={this.clearSearch}
          >
            {this.props.t("CustomerReservations.clear")}
          </button>
        </div>
      </div>
    );
  }

  createTablesCopy = () => {
    this.tablesCopy = JSON.parse(JSON.stringify(this.state.tables));
  };

  getTabs() {
    const tabs = [];

    tabs.push(
      {
        menuName: this.props.t("CustomerReservations.inProgress"),
        enabled: true,
        id: "inProgress",
      },
      {
        menuName: this.props.t("CustomerReservations.history"),
        enabled: true,
        id: "history",
      }
    );
    return tabs;
  }

  render() {
    return (
      <div className="pageWrapper">
        {this.getSubNav()}
        {this.state.isDataLoaded ? (
          <>
            {this.searchOrdersComponent()}
            {Object.keys(this.state.tables).length !== 0 ? (
              Object.keys(this.state.tables).map((commonDealerId, index) => {
                return (
                  <CustomerReservationTable
                    {...this.props}
                    searchEnabled={this.state.searchEnabled}
                    key={index}
                    fromCrc={false}
                    index={index}
                    currentPage={this.state.tables[commonDealerId].currentPage}
                    commonDealerId={commonDealerId}
                    reservations={
                      this.state.tables[commonDealerId].reservations
                    }
                    numberOfPages={
                      this.state.tables[commonDealerId].numberOfPages
                    }
                    updateTables={this.updateTables}
                    totalNumberOfResults={
                      this.state.tables[commonDealerId].totalNumberOfResults
                    }
                    selectedTab={this.state.selectedTab}
                  />
                );
              })
            ) : (
              <div
                className="pagePadding"
                data-testid="notFound"
                key="none-found"
              >
                {this.props.t("CustomerReservations.notFound")}
              </div>
            )}
          </>
        ) : this.state.fetchFailed ? (
          <div className={styles.errorText}>
            <h2>{this.props.t("FetchError.errorText")}</h2>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withTranslation("emp")(CustomerReservations);
